<template>
	<div class="flex flex-1 h-screen justify-center items-center sm:mx-12 lg:mx-24 xl:mx-40">
		<div class="flex flex-1 lg:mr-12">
			<app-section class="flex flex-1 flex-col h-auto bg-white shadow-2xl m-4">
				<div class="flex flex-1 justify-center my-4">
					<img src="../assets/images/bab10vite.png" alt="Logo" :width="100" />
				</div>
				<div class="text-center mb-8">
					<span class="text-16 font-thin">
						Welcome to Baboon's administration panel
					</span>
				</div>
				<app-dynamic-form :schema="schema" @submit="login" v-model="formData">
					<app-button class="btn btn-primary w-full" type="submit" :loading="state.loading">
						Login
					</app-button>
					<app-progress-bar v-if="state.loading" mode="indeterminate" class="mt-2" />
				</app-dynamic-form>
			</app-section>
		</div>
		<div class="flex flex-1 ml-12 hidden md:flex">
			<img src="../assets/images/login-side-image.png" alt="Logo" />
		</div>
	</div>
</template>
<script>
	import Names from '@/router/names';
	import * as yup from 'yup';
	import { useRouter } from 'vue-router';
	import { useStore } from 'vuex';
	import { getCurrentInstance, reactive, ref } from 'vue';
	import AppDynamicForm from '@/components/app/AppDynamicForm';
	import AppProgressBar from '@/components/app/AppProgressBar.vue';

	export default {
		components: {
			AppDynamicForm,
			AppProgressBar,
		},
		setup() {
			const instance = getCurrentInstance();
			const router = useRouter();
			const store = useStore();

			const schema = ref({
				username: {
					component: 'app-input',
					name: 'username',
					placeholder: 'Email',
					type: 'text',
					icon: 'envelope',
					validations: yup
						.string()
						.email()
						.required()
						.label('Email'),
				},
				password: {
					component: 'app-input',
					name: 'password',
					placeholder: 'Password',
					type: 'password',
					icon: 'lock',
					validations: yup
						.string()
						.required()
						.label('Password'),
				},
			});

			const formData = ref({
				username: '',
				password: '',
			});

			const state = reactive({
				loading: false,
			});

			function login() {
				const user = formData.value;
				user.userType = 0;
				state.loading = true;
				store
					.dispatch('login', user)
					.then(() => {
						store.dispatch('getLocations');
						store.dispatch('getPosSettings');
						state.loading = false;
						router.replace({ name: Names.OrdersList });
					})
					.catch((error) => {
						state.loading = false;
						if (error.status === 401 || error.status === 403) {
							instance.appContext.config.globalProperties.$notificationService.error(
								"We couldn't find any account matching your credentials!"
							);
						} else {
							instance.appContext.config.globalProperties.$notificationService.error(
								error || 'An error occurred during login. Please try again.'
							);
						}
					});
			}

			return {
				login,
				state,
				schema,
				formData,
			};
		},
	};
</script>
